import React, { createContext, useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // token loads immediately from localStorage
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const [userName, setUserName] = useState(() => localStorage.getItem("userName"));
    const [agencyId, setAgencyId] = useState(() => localStorage.getItem("agencyId"));
    const [name, setName] = useState(() => localStorage.getItem("name"));

    // const login = (newToken) => {
    //     localStorage.setItem("token", newToken);  // 1. Browser storage
    //     setToken(newToken);                       // 2. React Context state
    // };

    const login = (newToken, userName, agencyId, name) => {
        localStorage.setItem("token", newToken);  // 1. Browser storage
        localStorage.setItem("userName", userName);
        localStorage.setItem("agencyId", agencyId);
        localStorage.setItem("name", name);

        setToken(newToken);  // 2. React Context state
        setUserName(userName);
        setAgencyId(agencyId);
        setName(name);
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("agency");

        setToken(null);
        setUserName(null);
        setAgencyId(null);
        setName(null);
        //navigate("/login", { replace: true }); //  Prevent back navigation
    };

    return (
        <AuthContext.Provider value={{ token,userName,agencyId,name, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
